// Auto-generated index of all GraphQL queries
import { gql } from "@apollo/client";

// Import all query files
import budgetDataQuery from "./budgetData.graphql?raw";
import climateDataQuery from "./climateData.graphql?raw";
import customersQuery from "./customers.graphql?raw";
import customerFieldsFragment from "../fragments/customerFields.graphql?raw";
import dataHubCustomerBuildingsQuery from "./dataHubCustomerBuildings.graphql?raw";
import dataHubCustomersQuery from "./dataHubCustomers.graphql?raw";
import dataLimitListQuery from "./dataLimitList.graphql?raw";
import datahubBuildingMetersQuery from "./datahubBuildingMeters.graphql?raw";
import datahubMeteringdataDailyQuery from "./datahubMeteringdataDaily.graphql?raw";
import datahubMeteringdataTsMonthlyQuery from "./datahubMeteringdataTsMonthly.graphql?raw";
import datahubMeteringdataTsYearlyQuery from "./datahubMeteringdataTsYearly.graphql?raw";
import energyDataQuery from "./energyData.graphql?raw";
import generateCostStatementFileQuery from "./generateCostStatementFile.graphql?raw";
import generateEnergyStatementFileQuery from "./generateEnergyStatementFile.graphql?raw";
import generateTariffStatementFileQuery from "./generateTariffStatementFile.graphql?raw";
import getActiveUsersQuery from "./getActiveUsers.graphql?raw";
import getAllModulesQuery from "./getAllModules.graphql?raw";
import getAllNotificationsQuery from "./getAllNotifications.graphql?raw";
import getAllPartnersQuery from "./getAllPartners.graphql?raw";
import getCompaniesBuildingsQuery from "./getCompaniesBuildings.graphql?raw";
import getCompanyUsersListQuery from "./getCompanyUsersList.graphql?raw";
import getCountriesQuery from "./getCountries.graphql?raw";
import getCustomerCountriesQuery from "./getCustomerCountries.graphql?raw";
import getCountryAddressesQuery from "./getCountryAddresses.graphql?raw";
import getDealByIdQuery from "./getDealById.graphql?raw";
import getDealsListQuery from "./getDealsList.graphql?raw";
import getGroupsQuery from "./getGroups.graphql?raw";
import getMeterBroadcastDataQuery from "./getMeterBroadcastData.graphql?raw";
import getMetersDataQueryQuery from "./getMetersDataQuery.graphql?raw";
import getNewNotificationsQuery from "./getNewNotifications.graphql?raw";
import getNotificationQuery from "./getNotification.graphql?raw";
import getPartnerUsersListQuery from "./getPartnerUsersList.graphql?raw";
import getPublicTokenQuery from "./getPublicToken.graphql?raw";
import getScrapperListQuery from "./getScrapperList.graphql?raw";
import getScrapperLogsQuery from "./getScrapperLogs.graphql?raw";
import getSettingsQuery from "./getSettings.graphql?raw";
import getSubscriptionFeaturesQuery from "./getSubscriptionFeatures.graphql?raw";
import getSubscriptionPlansQuery from "./getSubscriptionPlans.graphql?raw";
import getSystemUsersListQuery from "./getSystemUsersList.graphql?raw";
import getTimezonesQuery from "./getTimezones.graphql?raw";
import getUsersListQuery from "./getUsersList.graphql?raw";
import getUserCompaniesQuery from "./getUserCompanies.graphql?raw";
import getUserProfileQuery from "./getUserProfile.graphql?raw";
import getWaterQueryQuery from "./getWaterQuery.graphql?raw";
import meQuery from "./me.graphql?raw";
import monthlyStatementDataQuery from "./monthlyStatementData.graphql?raw";
import taxesInvoicesQuery from "./taxesInvoices.graphql?raw";
import tariffDetailsQuery from "./tariffDetails.graphql?raw";
import tenantsCompaniesListQuery from "./tenantsCompaniesList.graphql?raw";
import tenantsListQuery from "./tenantsList.graphql?raw";
import tenantsUsersListQuery from "./tenantsUsersList.graphql?raw";

import settingKeysQuery from "./settingKeys.graphql?raw";
import tenantSettingsQuery from "./tenantSettings.graphql?raw";
import partnerSettingsQuery from "./partnerSettings.graphql?raw";
import userSettingsQuery from "./userSettings.graphql?raw";

// Export all queries
export const queries = {
  userSettings: gql(userSettingsQuery),
  tenantSettings: gql(tenantSettingsQuery),
  partnerSettings: gql(partnerSettingsQuery),
  settingKeys: gql(settingKeysQuery),
  budgetData: gql(budgetDataQuery),
  climateData: gql(climateDataQuery),
  customers: gql(
    customersQuery +
      `
` +
      customerFieldsFragment,
  ),
  dataHubCustomerBuildings: gql(dataHubCustomerBuildingsQuery),
  dataHubCustomers: gql(dataHubCustomersQuery),
  dataLimitList: gql(dataLimitListQuery),
  datahubBuildingMeters: gql(datahubBuildingMetersQuery),
  datahubMeteringdataDaily: gql(datahubMeteringdataDailyQuery),
  datahubMeteringdataTsMonthly: gql(datahubMeteringdataTsMonthlyQuery),
  datahubMeteringdataTsYearly: gql(datahubMeteringdataTsYearlyQuery),
  energyData: gql(energyDataQuery),
  generateCostStatementFile: gql(generateCostStatementFileQuery),
  generateEnergyStatementFile: gql(generateEnergyStatementFileQuery),
  generateTariffStatementFile: gql(generateTariffStatementFileQuery),
  getActiveUsers: gql(getActiveUsersQuery),
  getAllModules: gql(getAllModulesQuery),
  getAllNotifications: gql(getAllNotificationsQuery),
  getAllPartners: gql(getAllPartnersQuery),
  getCompaniesBuildings: gql(getCompaniesBuildingsQuery),
  getCompanyUsersList: gql(getCompanyUsersListQuery),
  getCountries: gql(getCountriesQuery),
  getCustomerCountries: gql(getCustomerCountriesQuery),
  getCountryAddresses: gql(getCountryAddressesQuery),
  getDealById: gql(getDealByIdQuery),
  getDealsList: gql(getDealsListQuery),
  getGroups: gql(
    getGroupsQuery +
      `
` +
      customerFieldsFragment,
  ),
  getMeterBroadcastData: gql(getMeterBroadcastDataQuery),
  getMetersDataQuery: gql(getMetersDataQueryQuery),
  getNewNotifications: gql(getNewNotificationsQuery),
  getNotification: gql(getNotificationQuery),
  getPartnerUsersList: gql(getPartnerUsersListQuery),
  getPublicToken: gql(getPublicTokenQuery),
  getScrapperList: gql(getScrapperListQuery),
  getScrapperLogs: gql(getScrapperLogsQuery),
  getSettings: gql(getSettingsQuery),
  getSubscriptionFeatures: gql(getSubscriptionFeaturesQuery),
  getSubscriptionPlans: gql(getSubscriptionPlansQuery),
  getSystemUsersList: gql(getSystemUsersListQuery),
  getTimezones: gql(getTimezonesQuery),
  getUsersList: gql(getUsersListQuery),
  getUserCompanies: gql(getUserCompaniesQuery),
  getUserProfile: gql(getUserProfileQuery),
  getWaterQuery: gql(getWaterQueryQuery),
  me: gql(meQuery),
  monthlyStatementData: gql(monthlyStatementDataQuery),
  taxesInvoices: gql(taxesInvoicesQuery),
  tariffDetails: gql(tariffDetailsQuery),
  tenantsCompaniesList: gql(
    tenantsCompaniesListQuery +
      `
` +
      customerFieldsFragment,
  ),
  tenantsList: gql(tenantsListQuery),
  tenantsUsersList: gql(tenantsUsersListQuery),
};
